import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom'
import { viewFilePath } from '../../library/utilities';
import styles from './pdf-viewer.module.scss';

const PDFViewer = ({ path, type }) => {
    const { quotationToken } = useParams()
    const { t } = useTranslation()
    if (type === "pdf") {
        return (
            <>
                <iframe title="Preview" className={styles.frame}
                    src={viewFilePath(path, quotationToken)} width="100%"
                    height="500px">
                </iframe>
                <a className={`button--primary ${styles.openExternal}`} href={viewFilePath(path, quotationToken)} target="_blank" rel="noopener noreferrer">
                    <img src="/icons/lens-plus.svg" alt="" />{t("View")}
                </a>
            </>
        )
    }
    else if (type === "svg") {
        return (
            <img src={viewFilePath(path, quotationToken)} alt="preview" width="100%"
                height="500px" className={styles.frame} style={{ objectFit: 'contain' }} />
        )
    }
    else {
        return (
            <object
                //type='application/pdf'
                data={viewFilePath(path, quotationToken)} // Replace with the path to your PDF file
                width="100%"
                height="500px"
                className={styles.frame}>
            </object>

        );
    }

}


PDFViewer.propTypes = {
    path: PropTypes.string,
    type: PropTypes.string,
    project_id: PropTypes.number,

}

export default PDFViewer